import React, {CSSProperties, useRef, useState} from "react";
import {BroadcastUtils, EnvironmentUtils, Media, ProductItem} from "filkersjs-model/dist";
import MediaCard from "src/components/media/MediaCard";
import {useCreation, useSize} from "ahooks";

export interface ItemMediaCarrouselProps {
    item: ProductItem,
    style?: CSSProperties
}

const ItemMediaCarrousel = ({item, style = {}}: ItemMediaCarrouselProps) => {

    const [selectedMedia, setSelectedMedia] = useState<Media>(
        item !== undefined && item.media !== undefined && item.media.length > 0
            ? item.media[0]
            : undefined
    );

    const mainViewRef = useRef<HTMLDivElement>();
    const mainViewSize = useSize(mainViewRef);
    const mainViewVersionUrl = useCreation(() => {
        if (selectedMedia === undefined || mainViewSize === undefined || mainViewSize.width === undefined || mainViewSize.width < 1) {
            return undefined;
        }
        const mediaResult = BroadcastUtils.getMediaVersionSelectionStrategy().findMediaVersion(selectedMedia, mainViewSize.width, mainViewSize.height);
        return EnvironmentUtils.getMediaBaseUrl(mediaResult.media).concat(mediaResult.version.path);
    }, [selectedMedia, mainViewSize]);


    return (
        <div style={{...style, display: "flex", flexDirection: "column"}}>

            <div
                ref={mainViewRef}
                style={{
                    flexGrow: 1,
                    marginTop: "1vh",
                    backgroundImage: mainViewVersionUrl === undefined ? undefined : `url(${mainViewVersionUrl})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    backgroundSize: "contain"

                }}
            >

            </div>

            <div style={{height: "16vh", display: "flex", justifyContent: "space-between"}}>
                {item.media !== undefined && item.media.length > 0 ? (
                    item.media.map(m =>
                        <div
                            key={m.uid}
                            className="flk-clickable-item"
                            style={{width: "16vh", margin: "1vh"}}
                            onClick={(event) => {
                                event.stopPropagation();
                                setSelectedMedia(m);
                            }}
                        >
                            <MediaCard media={m}/>
                        </div>
                    )
                ) : null}
            </div>
        </div>
    );
}

export default ItemMediaCarrousel;
